// removed by extract-text-webpack-plugin
module.exports = {"Block":"_2q-XcM509ueQuiJUMGul2t","Col_10per":"_1Rt7EkpUTPnwIECRWqX18a","Col_30per":"_2LT7Hdq2T5zEQBn25dfOlz","Col_20per":"_2P-qNmxP9yeg_4LAWJzL7E","Divider":"_1EPnRhd3we9El630DfQiN0","BlockTitle":"_1GdSaX_SK89l2M2KlTgCO7","Footer":"_3gOY9c34mORtvdL5g8vltj","Select":"_28xP7PkZSBHcBJA3CO5Mmk"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/ReportConstructor/styles.module.css
// module id = 617
// module chunks = 0